import { MissionType } from "../../types";

const goldenHandshake: MissionType = {
  location: "New York",
  title: "Golden Handshake",
  version: 2,
  targets: ["Athenas Savalas"],
  disguises: [
    { name: "The New Yorker", outfit: false },
    { name: "Bank Robber" },
    { name: "Bank Teller" },
    { name: "Fired Banker" },
    { name: "High Security Guard" },
    { name: "Investment Banker" },
    { name: "IT Worker" },
    { name: "Janitor" },
    { name: "Job Applicant" },
    { name: "Security Guard" },
  ],
  weapons: [
    { name: "Antique Curved Knife" },
    { name: "Burial Dagger" },
    { name: "Earphones" },
    { name: "Fire Axe" },
    { name: "Folding Knife" },
    { name: "Hobby Knife" },
    { name: "Kitchen Knife" },
    { name: "Letter Opener" },
    { name: "Scissors" },
    { name: "Screwdriver" },
    { name: "Tanto" },
  ],
};

export default goldenHandshake;
